var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'btn-rounded light-gray px-4': true,
    'not-allowed black-text': _vm.btnDisable,
    'btn-rounded__hover': !_vm.btnDisable
  },attrs:{"type":_vm.buttonType,"disabled":_vm.btnDisable},on:{"click":function($event){return _vm.toggle()}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }